import { ServiceBoxWrapper, Wrapper } from "./style";
import logo from "../../assets/images/Bbpslogo3.svg"
import { providerTypeOptions } from "./constants";
import { useNavigate } from "react-router-dom";
import Back from "../UIbox/Back";
import { useContext, useEffect } from "react";
import { GlobleContaxt } from "../../Context/GlobleContaxt";
import { isEmpty } from "../../utils/common";
// import GrowYourBussion from "../GrowYourBussion/GrowYourBussion";



 const ServicesBox = ()  =>{
	 const navigate = useNavigate();


   const { userDetails, apiPermission } = useContext(GlobleContaxt);

   useEffect(() => {
    if (isEmpty(userDetails?.userName) || apiPermission?.includes('BBPS')) return;
    navigate('/');
  
}, [userDetails]);
   
	return(
        <>
        <div className="container">
				<div className="Home-page">
                <Wrapper className={`tab-content-wrapper bbps`}>
				
					
					
                <>  <ServiceBoxWrapper>
        <div className='header flex justify-between items-center'>
            {/* <h2 className="m0"></h2> */}
            <Back url="/services" />
                <h2 className="m0">Bharat Connect Services</h2>
            <div className="logo">
                <img src={logo} alt="bbps logo" />
            </div>

        </div>
        <div className="service-box-body">
        <h2>Recharge & pay bills and do a lot more.</h2>
        <div className="service-box flex">
          {
            providerTypeOptions.map((item, index) =>{
                  return (<div className="serviceCard center" onClick={() =>navigate('/bbps-payments', { state:item })}>
                    <div key={index}>
                         <img src={item.img} alt={item?.label} />
                         <h3>{item?.label}</h3>
                    </div>
              </div>)
            })
                         }
            

        </div>
        </div>
        
     </ServiceBoxWrapper>
                </>

            </Wrapper>
				</div>
			</div>
			{/* <AboutPay2Mobile />
			<FooterContent />
			<GrowYourBussion /> */}
			{/* <DownloadPay2Mobile /> */}
			
			{/* {controls.providerType === 'MOBILE_RECHARGE' && <BBPSMobileRecharge changesProvider={changesProvider} controls={controls} />}

			{controls.providerType === 'DTH' && <BBPSDth changesProvider={changesProvider} controls={controls} />} */}
		</>
		
	)
}

export default ServicesBox;